// react-flow related styles
export const defaultNodeStyle = {
  backgroundColor: 'var(--rs-color-background-base-primary)',
  border: `1px solid var(--rs-color-border-base-primary)`,
  padding: '8px',
  borderRadius: '4px',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06)'
};

export const SelectedNodeStyle = {
  backgroundColor: 'var(--rs-color-background-base-primary)',
  border: `1px solid var(--rs-color-border-accent-emphasis)`,
  padding: '8px',
  borderRadius: '4px',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06)'
};
